import api from "../../util/api";

export const uploadImage = async ({id, file, onSuccess, onError}) => {
    let formData = new FormData();
    formData.append("avatar", file);

    return await api
        .post(`v2/api/speakers/${id}/upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then(({data}) => {
            if (data.result && data.result === "success") onSuccess();
            else onError();
            return data;
        })
        .catch(err => {
            onError();
            console.error(err);
            return false;
        });
};
